/**
 * Reusable regular expressions for through LA code
 */

export default {
    /**
      * decent email check without being insane
      * this will not cover full international addresses which at some point will probably start to be an issue
      */
    email: /^<?(['a-zA-Z0-9_=\.\-\+&!#\$%\*\?\^\|\{\}\~])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+>?$/i,
    /**
      * URL check, not perfect
      */
    url: /^((mailto|https?):)*\/\/.+/i,
    /**
      * Phone number / sms numbers, no spaces or punctuation
      * except optional starting +
      */
    phone: /^\+?[0-9]{10,}$/,
    /**
      * Date in the format yyyy-mm-dd
      */
    date: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
    /**
      * Date time in format yyyy-mm-dd hh:mm with optional :ss
      */
    datetime: /^[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{1,2}:[0-9]{2}(:[0-9]{2})?$/,
    /**
      * HTML hex color
      */
    color: /^#([a-f0-9A-F]{6}|[a-f0-9A-F]{3})$/
};
